/**
 * /fasting-window — окно питания при интервальном голодании.
 *
 * Тул отвечает на ДВА разных вопроса, и это две его половины:
 *
 *   «Расписание» — у меня схема 16:8, когда мне закрывать окно и когда снова
 *                  есть. Это то, с чем приходят из поиска.
 *   «Таймер»     — я перестал есть в 20:14, сколько я уже держусь и когда
 *                  доберу до цели. Это то, с чем возвращаются каждый день.
 *
 * Обе половины делят ОДИН циферблат суток: расписание рисует плановые дуги,
 * таймер докладывает поверх них фактическую дугу голодания. Один смысловой
 * объект вместо двух приборов — иначе переключение режима каждый раз стоит
 * читателю заново разобраться, что он видит.
 *
 * ЧТО ЗДЕСЬ ЕСТЬ, ЧЕГО НЕТ У КОНКУРЕНТОВ (обзор 2026-09-05, семь веб-тулов и
 * три приложения):
 *   • стадии голодания с ЧЕСТНОЙ пометкой доказанности. Все показывают
 *     «16 ч → аутофагия» как факт; у человека сроки не измерены (NCT04842864 —
 *     идущее исследование ровно про это). Мы показываем ту же шкалу, но
 *     называем, что замерено у людей, а что перенесено с мышей;
 *   • совмещение окна со СНОМ: сколько часов голодания приходится на сон и
 *     насколько поздно закрывается окно. Раннее окно (eTRF) — единственная
 *     часть темы с внятными человеческими данными, и это единственный совет,
 *     который тул себе позволяет;
 *   • «что нарушает голодание» как ПОИСК по 28 позициям, а не список из шести
 *     пунктов: именно этим вопросом заканчивается почти каждая сессия.
 *
 * Состояние целиком локальное (`__toolSettings`, ключ `state`). Журнал
 * зеркалится в аккаунт только у Премиума (feature `fasting_cloud_sync`) — тот
 * же localStorage-first договор, что у /word-of-the-day и /english-grammar-course.
 */
(function () {
    'use strict';

    var root = document.getElementById('fwApp');
    if (!root) return;

    var T = window.FW_I18N || {};
    var SLUG = 'fasting-window';
    var DAY = 1440;                       // минут в сутках
    var MS_DAY = 86400000;
    var STORE = 'state';
    var SYNC_URL = '/api/fasting-log';
    var MAX_LOG = 400;

    function t(k, fb) { return (T && T[k] != null) ? T[k] : (fb != null ? fb : ''); }
    function $(id) { return document.getElementById(id); }
    function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }
    function toast(m, kind) { try { if (window.__toast) window.__toast(m, kind || 'info'); } catch (e) {} }
    function feature(name, p) {
        try { if (window.__ae) window.__ae('feature_use', Object.assign({ f: name, slug: SLUG }, p || {})); } catch (e) {}
    }
    var _stages = {};
    function stage(name, meta) {
        if (_stages[name]) return;
        _stages[name] = 1;
        try { if (window.__stage) window.__stage(name, meta || {}); } catch (e) {}
    }

    /* ─────────────────────────── форматирование ─────────────────────────── */

    var LOCALE = (window.__LOCALE || document.documentElement.lang || 'en').split('-')[0];
    var timeFmt = null, dateFmt = null;
    try { timeFmt = new Intl.DateTimeFormat(LOCALE, { hour: '2-digit', minute: '2-digit' }); } catch (e) {}
    try { dateFmt = new Intl.DateTimeFormat(LOCALE, { day: 'numeric', month: 'short' }); } catch (e) {}

    /* Intl.DurationFormat — Baseline 2025. Там, где он есть, «16 ч 30 мин»
       склоняется по правилам языка; где нет — собираем из тех же двух подписей,
       что рисует остальной интерфейс. Ни одна ветка не оставляет число без
       единицы измерения. */
    var durFmt = null;
    try { if (typeof Intl !== 'undefined' && Intl.DurationFormat) durFmt = new Intl.DurationFormat(LOCALE, { style: 'narrow' }); } catch (e) {}

    function clock(mins) {
        mins = ((Math.round(mins) % DAY) + DAY) % DAY;
        var d = new Date(2000, 0, 1, Math.floor(mins / 60), mins % 60, 0, 0);
        if (timeFmt) return timeFmt.format(d);
        return String(Math.floor(mins / 60)).padStart(2, '0') + ':' + String(mins % 60).padStart(2, '0');
    }
    function clockOf(ms) {
        var d = new Date(ms);
        return timeFmt ? timeFmt.format(d)
            : String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    }
    /** Длительность в минутах → «16 ч 30 мин» / «16 ч». */
    function dur(mins) {
        mins = Math.max(0, Math.round(mins));
        var h = Math.floor(mins / 60), m = mins % 60;
        if (durFmt) {
            try { return durFmt.format(m ? { hours: h, minutes: m } : { hours: h }); } catch (e) {}
        }
        return m ? (h + ' ' + t('u_h') + ' ' + m + ' ' + t('u_m')) : (h + ' ' + t('u_h'));
    }
    function hhmmss(mins) {
        var total = Math.max(0, Math.floor(mins * 60));
        var h = Math.floor(total / 3600), m = Math.floor((total % 3600) / 60), s = total % 60;
        return h + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    }
    /* Секунды — мелкими. Не украшение: «2:37:57» целиком крупным кеглем не
       помещается в отверстие циферблата ни на одном размере экрана, а
       уменьшать ЧАСЫ значит уменьшать то единственное число, ради которого
       сюда и приходят. */
    function countHtml(mins) {
        var p = hhmmss(mins).split(':');
        return esc(p[0] + ':' + p[1]) + '<i class="fw-sec">' + esc(p[2]) + '</i>';
    }
    function hm(str) {                       // "07:30" → 450
        var p = String(str || '').split(':');
        var h = parseInt(p[0], 10), m = parseInt(p[1], 10);
        if (!isFinite(h) || !isFinite(m)) return null;
        return ((h * 60 + m) % DAY + DAY) % DAY;
    }
    function toHm(mins) {                    // 450 → "07:30"
        mins = ((Math.round(mins) % DAY) + DAY) % DAY;
        return String(Math.floor(mins / 60)).padStart(2, '0') + ':' + String(mins % 60).padStart(2, '0');
    }
    function ymd(ms) {
        var d = new Date(ms);
        return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    }

    /* ─────────────────────────── схемы ─────────────────────────── */

    /* fast = часы голодания; окно еды = 24 − fast. У «своей» схемы человек
       задаёт то же самое число часов голодания, поэтому вычитание одно на все
       ветки и разойтись им негде. */
    var SCHEMES = [
        { id: '12', fast: 12 },
        { id: '14', fast: 14 },
        { id: '16', fast: 16 },
        { id: '18', fast: 18 },
        { id: '20', fast: 20 },
        { id: 'omad', fast: 23 },
        { id: 'custom', fast: 16 }
    ];
    function schemeById(id) {
        for (var i = 0; i < SCHEMES.length; i++) if (SCHEMES[i].id === id) return SCHEMES[i];
        return SCHEMES[2];
    }
    function fastHours() {
        if (S.scheme === 'custom') return Math.min(23, Math.max(10, S.customFast || 16));
        return schemeById(S.scheme).fast;
    }
    function eatHours() { return 24 - fastHours(); }

    /* ─────────────────────────── состояние ─────────────────────────── */

    var DEFAULTS = {
        v: 1,
        scheme: '16',
        customFast: 16,
        start: 12 * 60,          // первый приём пищи, минуты от полуночи
        sleepOn: true,
        sleepStart: 23 * 60,
        sleepEnd: 7 * 60,
        mode: 'plan',
        active: null,            // { s: startedAtMs, t: targetHours }
        log: [],                 // [{ id, s, e, t, u }]
        remind: false,
        tab: 'drinks',
        u: 0
    };
    var S = null;

    function clampMin(v, fb) {
        v = parseInt(v, 10);
        return (isFinite(v) && v >= 0 && v < DAY) ? v : fb;
    }
    function loadState() {
        var raw = null;
        try { raw = window.__toolSettings ? window.__toolSettings.load(SLUG, STORE, null) : null; } catch (e) {}
        S = Object.assign({}, DEFAULTS, (raw && typeof raw === 'object') ? raw : {});
        if (!Array.isArray(S.log)) S.log = [];
        if (S.active && (typeof S.active.s !== 'number' || !isFinite(S.active.s))) S.active = null;
        /* Отсчёт, начатый больше недели назад, — почти наверняка забытая
           вкладка, а не рекордный пост: он показал бы «180:14:07» и сделал бы
           журнал бессмысленным. Забываем молча и в журнал НЕ пишем: записать
           означало бы придумать за человека, когда он поел. */
        if (S.active && Date.now() - S.active.s > 7 * MS_DAY) S.active = null;
        S.start = clampMin(S.start, 12 * 60);
        S.sleepStart = clampMin(S.sleepStart, 23 * 60);
        S.sleepEnd = clampMin(S.sleepEnd, 7 * 60);
    }
    var saveTimer = null;
    function save(now) {
        S.u = Date.now();
        var doIt = function () {
            saveTimer = null;
            try { if (window.__toolSettings) window.__toolSettings.save(SLUG, STORE, S); } catch (e) {}
        };
        if (saveTimer) clearTimeout(saveTimer);
        if (now) { doIt(); return; }
        saveTimer = setTimeout(doIt, 400);
    }

    /* ─────────────────────────── расчёт ─────────────────────────── */

    /** Пересечение двух круговых интервалов, в минутах. */
    function overlapMin(aStart, aLen, bStart, bLen) {
        if (aLen <= 0 || bLen <= 0) return 0;
        var total = 0;
        /* Разворачиваем второй интервал на трое суток и считаем линейно:
           круговой случай с пересечением полуночи иначе требует четырёх
           ветвей, из которых одна всегда написана неверно. */
        for (var k = -1; k <= 1; k++) {
            var b0 = bStart + k * DAY, b1 = b0 + bLen;
            var lo = Math.max(aStart, b0), hi = Math.min(aStart + aLen, b1);
            if (hi > lo) total += hi - lo;
        }
        return Math.min(total, Math.min(aLen, bLen));
    }

    function plan() {
        var eatLen = eatHours() * 60;
        var eatStart = S.start;
        var eatEnd = (eatStart + eatLen) % DAY;
        var fastLen = DAY - eatLen;
        var sleepLen = S.sleepOn ? ((((S.sleepEnd - S.sleepStart) % DAY) + DAY) % DAY) : 0;
        return {
            eatStart: eatStart, eatEnd: eatEnd, eatLen: eatLen,
            fastStart: eatEnd, fastLen: fastLen,
            sleepStart: S.sleepStart, sleepLen: sleepLen,
            sleepInFast: sleepLen > 0 ? overlapMin(eatEnd, fastLen, S.sleepStart, sleepLen) : 0,
            sleepInEat: sleepLen > 0 ? overlapMin(eatStart, eatLen, S.sleepStart, sleepLen) : 0
        };
    }

    function nowMinutes() {
        var d = new Date();
        return d.getHours() * 60 + d.getMinutes() + d.getSeconds() / 60;
    }

    /** Где мы внутри планового расписания прямо сейчас. */
    function phase() {
        var p = plan();
        var n = nowMinutes();
        var since = ((n - p.eatStart) % DAY + DAY) % DAY;
        var eating = since < p.eatLen;
        return {
            eating: eating,
            leftMin: eating ? (p.eatLen - since) : (DAY - since),
            boundary: eating ? p.eatEnd : p.eatStart,
            /* Сколько часов голодания уже за плечами ПО ПЛАНУ — этим кормится
               шкала стадий, когда фактический отсчёт не запущен. */
            fastedMin: eating ? 0 : (since - p.eatLen)
        };
    }

    /* ─────────────────────────── стадии ─────────────────────────── */

    /* Часы — НАЧАЛО стадии. `ev` — уровень доказанности у человека:
       human = измерено, thin = данных мало, mouse = в основном на грызунах.
       Подписи приходят из перевода; здесь только числа и уровень доверия,
       потому что именно они и есть содержательная часть этой шкалы. */
    var STAGES = [
        { id: 'fed', from: 0, ev: 'human' },
        { id: 'glycogen', from: 4, ev: 'human' },
        { id: 'switch', from: 12, ev: 'human' },
        { id: 'ketosis', from: 16, ev: 'human' },
        { id: 'deep', from: 24, ev: 'human' },
        { id: 'autophagy', from: 36, ev: 'mouse' }
    ];
    var RAIL_MAX = 24;   // шкала рисуется до суток; дальше живёт только в списке

    function stageAt(h) {
        var cur = STAGES[0];
        for (var i = 0; i < STAGES.length; i++) if (h >= STAGES[i].from) cur = STAGES[i];
        return cur;
    }

    /* ─────────────────────────── циферблат ─────────────────────────── */

    /* Геометрия подобрана вокруг ОДНОГО жёсткого ограничения: центр обязан
       вместить крупный отсчёт. Внутренний квадрат, вписанный в отверстие
       радиуса r, равен r·√2 — поэтому дуга фактического голодания едет не
       отдельным кольцом снаружи (тогда цифры часов некуда девать) и не внутри
       (тогда отверстие съедается), а по ВНЕШНЕЙ КРОМКЕ основной полосы. Так
       она и читается правильно: факт поверх плана.
       Первая версия ставила цифры часов внутрь кольца — они наезжали на
       отсчёт на всех размерах экрана (замер 05.09). */
    var R_RING = 86, R_LIVE = 92, R_SLEEP = 72, CX = 120, CY = 120;
    var C_RING = 2 * Math.PI * R_RING, C_LIVE = 2 * Math.PI * R_LIVE, C_SLEEP = 2 * Math.PI * R_SLEEP;

    function arcAttrs(el, startMin, lenMin, circumference) {
        var len = Math.max(0, Math.min(DAY, lenMin)) / DAY * circumference;
        el.setAttribute('stroke-dasharray', len.toFixed(2) + ' ' + (circumference - len + 1).toFixed(2));
        el.setAttribute('transform', 'rotate(' + (startMin / DAY * 360 - 90).toFixed(3) + ' ' + CX + ' ' + CY + ')');
    }

    function buildDial() {
        var svg = $('fwDialSvg');
        if (!svg) return;
        var ticks = '', labels = '';
        for (var i = 0; i < 24; i++) {
            var major = i % 6 === 0;
            var a = (i / 24 * 360 - 90) * Math.PI / 180;
            var r1 = 98, r2 = major ? 105 : 102;
            ticks += '<line x1="' + (CX + r1 * Math.cos(a)).toFixed(1) + '" y1="' + (CY + r1 * Math.sin(a)).toFixed(1)
                + '" x2="' + (CX + r2 * Math.cos(a)).toFixed(1) + '" y2="' + (CY + r2 * Math.sin(a)).toFixed(1)
                + '" class="fw-tick' + (major ? ' fw-tick-major' : '') + '"/>';
        }
        [0, 6, 12, 18].forEach(function (h) {
            var a = (h / 24 * 360 - 90) * Math.PI / 180;
            labels += '<text x="' + (CX + 114 * Math.cos(a)).toFixed(1) + '" y="' + (CY + 114 * Math.sin(a) + 3.6).toFixed(1)
                + '" class="fw-hour">' + h + '</text>';
        });
        svg.innerHTML =
            '<circle cx="120" cy="120" r="' + R_RING + '" class="fw-ring-track"/>' +
            '<circle cx="120" cy="120" r="' + R_RING + '" class="fw-ring-eat" id="fwArcEat"/>' +
            '<circle cx="120" cy="120" r="' + R_SLEEP + '" class="fw-ring-sleep" id="fwArcSleep"/>' +
            '<circle cx="120" cy="120" r="' + R_LIVE + '" class="fw-ring-live" id="fwArcLive"/>' +
            ticks + labels +
            '<line x1="120" y1="120" x2="120" y2="120" class="fw-hand" id="fwHand"/>' +
            '<circle cx="120" cy="120" r="3.5" class="fw-hub"/>';
    }

    /* ─────────────────────────── отрисовка ─────────────────────────── */

    var lastGeomKey = '';

    function renderGeometry(force) {
        var p = plan();
        var key = [S.scheme, S.customFast, S.start, S.sleepOn, S.sleepStart, S.sleepEnd,
            S.active ? S.active.s : 0, S.active ? S.active.t : 0, S.mode].join('|');
        if (!force && key === lastGeomKey) return;
        lastGeomKey = key;

        var eat = $('fwArcEat'), sleep = $('fwArcSleep'), live = $('fwArcLive');
        if (eat) arcAttrs(eat, p.eatStart, p.eatLen, C_RING);
        if (sleep) {
            sleep.style.display = p.sleepLen > 0 ? '' : 'none';
            if (p.sleepLen > 0) arcAttrs(sleep, p.sleepStart, p.sleepLen, C_SLEEP);
        }
        if (live) {
            if (S.active) {
                var d0 = new Date(S.active.s);
                var startMin = d0.getHours() * 60 + d0.getMinutes();
                var elapsed = Math.min(DAY, (Date.now() - S.active.s) / 60000);
                live.style.display = '';
                arcAttrs(live, startMin, elapsed, C_LIVE);
            } else live.style.display = 'none';
        }
        renderStats();
        renderAdvice();
        renderRail();
    }

    function renderHand() {
        var hand = $('fwHand');
        if (!hand) return;
        var a = (nowMinutes() / DAY * 360 - 90) * Math.PI / 180;
        hand.setAttribute('x1', (CX + 40 * Math.cos(a)).toFixed(2));
        hand.setAttribute('y1', (CY + 40 * Math.sin(a)).toFixed(2));
        hand.setAttribute('x2', (CX + 96 * Math.cos(a)).toFixed(2));
        hand.setAttribute('y2', (CY + 96 * Math.sin(a)).toFixed(2));
    }

    function renderCenter() {
        var phEl = $('fwPhase'), cEl = $('fwCount'), tEl = $('fwTarget');
        if (!phEl) return;
        if (S.mode === 'timer' && S.active) {
            var elapsedMin = (Date.now() - S.active.s) / 60000;
            var targetMin = S.active.t * 60;
            var done = elapsedMin >= targetMin;
            root.setAttribute('data-phase', done ? 'done' : 'fast');
            phEl.textContent = done ? t('tm_reached') : t('tm_running');
            cEl.innerHTML = countHtml(elapsedMin);
            tEl.textContent = done
                ? t('tm_over').replace(':d', dur(elapsedMin - targetMin))
                : t('tm_left').replace(':d', dur(targetMin - elapsedMin)).replace(':time', clockOf(S.active.s + targetMin * 60000));
        } else if (S.mode === 'timer') {
            root.setAttribute('data-phase', 'idle');
            phEl.textContent = t('tm_idle');
            cEl.textContent = '—';
            tEl.textContent = t('tm_idle_hint');
        } else {
            var ph = phase();
            root.setAttribute('data-phase', ph.eating ? 'eat' : 'fast');
            phEl.textContent = ph.eating ? t('phase_eat') : t('phase_fast');
            cEl.innerHTML = countHtml(ph.leftMin);
            tEl.textContent = (ph.eating ? t('until_eat_end') : t('until_fast_end')).replace(':time', clock(ph.boundary));
        }
    }

    function renderStats() {
        var box = $('fwStats');
        if (!box) return;
        var p = plan();
        var rows;
        if (S.mode === 'timer') {
            /* Идущий отсчёт уже назван дважды — крупно в центре циферблата и
               строкой под ним. Третий повтор в тайлах был бы шумом, поэтому
               здесь стоит СВОДКА ЖУРНАЛА: пока держишься, полезен не таймер, а
               ответ «сколько таких уже было». У новичка это честные нули, а не
               сломанный вид. */
            var done = S.log.length;
            var avgMin = done ? S.log.reduce(function (a, x) { return a + (x.e - x.s) / 60000; }, 0) / done : 0;
            rows = [
                [t('j_streak'), String(streak())],
                [t('j_total'), String(done)],
                [t('j_avg'), done ? dur(avgMin) : '—']
            ];
        } else {
            rows = [
                [t('st_eat'), clock(p.eatStart) + ' — ' + clock(p.eatEnd)],
                [t('st_fast'), clock(p.fastStart) + ' — ' + clock(p.eatStart)],
                [t('st_sleep'), p.sleepLen > 0
                    ? t('st_sleep_v').replace(':a', Math.round(p.sleepInFast / 60)).replace(':b', Math.round(p.fastLen / 60))
                    : '—']
            ];
        }
        box.innerHTML = rows.map(function (r) {
            return '<div class="fw-stat"><span class="fw-stat-l">' + esc(r[0]) + '</span><b class="fw-stat-v">' + esc(r[1]) + '</b></div>';
        }).join('');
    }

    /* ── Совет по расположению окна ──
       Единственная часть темы с внятными человеческими данными — РАННЕЕ окно
       (eTRF) и поздний ужин. Поэтому совет здесь всегда про время суток и
       никогда про количество еды: последнего тул не знает и знать не может. */
    function advice() {
        var p = plan();
        if (!S.sleepOn || p.sleepLen <= 0) return null;
        var toSleep = ((S.sleepStart - p.eatEnd) % DAY + DAY) % DAY;   // от закрытия окна до сна
        var wakeToEat = ((p.eatStart - S.sleepEnd) % DAY + DAY) % DAY; // от подъёма до первой еды
        if (p.sleepInEat > 30) return { k: 'bad', text: t('adv_eat_in_sleep') };
        if (toSleep < 60) return { k: 'bad', text: t('adv_very_late').replace(':d', dur(toSleep)) };
        if (toSleep < 180) return { k: 'warn', text: t('adv_late').replace(':d', dur(toSleep)) };
        if (wakeToEat <= 120) return { k: 'good', text: t('adv_early') };
        if (p.sleepInFast >= p.fastLen * 0.5) return { k: 'good', text: t('adv_sleep_covers').replace(':a', Math.round(p.sleepInFast / 60)) };
        return { k: 'good', text: t('adv_ok').replace(':d', dur(toSleep)) };
    }

    function renderAdvice() {
        var el = $('fwAdvice');
        if (!el) return;
        if (S.mode === 'timer') { el.hidden = true; return; }
        var a = advice();
        if (!a) { el.hidden = true; return; }
        el.hidden = false;
        el.className = 'fw-advice fw-advice-' + a.k;
        el.innerHTML = '<span class="fw-advice-ico" aria-hidden="true">' + (a.k === 'good' ? '✓' : '!') + '</span>'
            + '<span>' + esc(a.text) + ' <button type="button" class="fw-link" data-goto="body">' + esc(t('adv_why')) + '</button></span>';
    }

    /* ── Шкала стадий ── */
    function fastedHoursNow() {
        if (S.active) return (Date.now() - S.active.s) / 3600000;
        var ph = phase();
        return ph.eating ? 0 : ph.fastedMin / 60;
    }

    function renderRail() {
        var el = $('fwRail');
        if (!el) return;
        var h = fastedHoursNow();
        var cur = stageAt(h);
        var pct = Math.max(0, Math.min(100, h / RAIL_MAX * 100));
        var visible = STAGES.filter(function (s) { return s.from < RAIL_MAX; });
        var segs = visible.map(function (s, i) {
            var next = visible[i + 1] ? visible[i + 1].from : RAIL_MAX;
            var cls = s.id === cur.id ? ' on' : (next <= h ? ' past' : '');
            return '<span class="fw-seg' + cls + '" style="flex:' + (next - s.from) + '"'
                + ' title="' + esc(s.from + '–' + next + ' ' + t('u_h') + ' · ' + t('stage_' + s.id)) + '"></span>';
        }).join('');
        var scale = [0, 6, 12, 18, 24].map(function (n) { return '<span>' + n + '</span>'; }).join('');
        el.innerHTML =
            '<div class="fw-rail-head">'
            + '<span class="fw-rail-now">' + esc(t('rail_now')) + ' <b>' + esc(dur(h * 60)) + '</b></span>'
            + '<span class="fw-rail-stage">' + esc(t('stage_' + cur.id)) + '</span>'
            + '<span class="fw-ev fw-ev-' + cur.ev + '">' + esc(t('ev_' + cur.ev)) + '</span>'
            + '</div>'
            + '<div class="fw-rail-bar"><div class="fw-rail-segs">' + segs + '</div>'
            + '<span class="fw-rail-mark" style="inset-inline-start:' + pct.toFixed(2) + '%"></span></div>'
            + '<div class="fw-rail-scale" aria-hidden="true">' + scale + '</div>'
            + '<div class="fw-rail-foot"><span>' + esc(t('stage_' + cur.id + '_d')) + '</span> '
            + '<button type="button" class="fw-link" data-goto="body">' + esc(t('rail_more')) + '</button></div>';
    }

    /* ─────────────────────────── управление ─────────────────────────── */

    function renderControls() {
        var chips = $('fwSchemes');
        if (chips && !chips.getAttribute('data-built')) {
            chips.setAttribute('data-built', '1');
            chips.innerHTML = SCHEMES.map(function (s) {
                return '<button type="button" class="fw-chip" role="radio" aria-checked="false" data-scheme="' + s.id + '">'
                    + esc(t('s_' + s.id)) + '</button>';
            }).join('');
        }
        if (chips) {
            Array.prototype.forEach.call(chips.querySelectorAll('.fw-chip'), function (b) {
                var on = b.getAttribute('data-scheme') === S.scheme;
                b.classList.toggle('on', on);
                b.setAttribute('aria-checked', on ? 'true' : 'false');
                b.tabIndex = on ? 0 : -1;
            });
        }
        var customBox = $('fwCustomBox');
        if (customBox) customBox.hidden = S.scheme !== 'custom';
        var ci = $('fwCustom');
        if (ci && document.activeElement !== ci) ci.value = S.customFast;

        var startEl = $('fwStart');
        if (startEl && document.activeElement !== startEl) startEl.value = toHm(S.start);
        var s1 = $('fwSleepStart'), s2 = $('fwSleepEnd'), sOn = $('fwSleepOn');
        if (s1 && document.activeElement !== s1) s1.value = toHm(S.sleepStart);
        if (s2 && document.activeElement !== s2) s2.value = toHm(S.sleepEnd);
        if (sOn) sOn.checked = !!S.sleepOn;
        var sleepFields = $('fwSleepFields');
        if (sleepFields) sleepFields.hidden = !S.sleepOn;

        Array.prototype.forEach.call(root.querySelectorAll('.fw-mode'), function (b) {
            var on = b.getAttribute('data-mode') === S.mode;
            b.classList.toggle('on', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
            b.tabIndex = on ? 0 : -1;
        });
        var planCtl = $('fwPlanCtl'), timerCtl = $('fwTimerCtl');
        if (planCtl) planCtl.hidden = S.mode !== 'plan';
        if (timerCtl) timerCtl.hidden = S.mode !== 'timer';

        var startedRow = $('fwStartedRow');
        if (startedRow) startedRow.hidden = !S.active;
        var startedEl = $('fwStarted');
        if (startedEl && S.active && document.activeElement !== startedEl) {
            var d = new Date(S.active.s);
            startedEl.value = toHm(d.getHours() * 60 + d.getMinutes());
        }
        var noFast = $('fwNoFast');
        if (noFast) noFast.hidden = !!S.active;

        var goBtn = $('fwGo');
        if (goBtn) {
            goBtn.textContent = S.active ? t('btn_finish') : t('btn_start');
            goBtn.classList.toggle('lg-btn-ghost', !!S.active);
        }
        var cancelBtn = $('fwCancel');
        if (cancelBtn) cancelBtn.hidden = !S.active;
    }

    /* ─────────────────────────── таймер голодания ─────────────────────────── */

    function startFast() {
        var target = fastHours();
        /* Кнопку нажимают не в ту секунду, когда доели, а когда вспомнили про
           тул. Если плановое окно СЕГОДНЯ уже закрылось и с тех пор прошло
           меньше цели — отсчёт начинается от закрытия, а не от «сейчас»;
           иначе человек каждый день терял бы по часу-двум своего же поста. */
        var p = plan();
        var n = nowMinutes();
        var sinceClose = ((n - p.eatEnd) % DAY + DAY) % DAY;
        var now = Date.now();
        var startMs = now;
        var backdated = 0;
        if (sinceClose > 5 && sinceClose < target * 60) { startMs = now - sinceClose * 60000; backdated = 1; }
        S.active = { s: startMs, t: target };
        S.mode = 'timer';
        save(true);
        renderControls();
        renderGeometry(true);
        renderCenter();
        scheduleReminders();
        feature('fw_fast_start', { target: target, backdated: backdated });
        stage('engaged');
    }

    function finishFast() {
        if (!S.active) return;
        var endMs = Date.now();
        var mins = (endMs - S.active.s) / 60000;
        if (mins < 1) { S.active = null; save(true); renderAll(); return; }
        var d0 = new Date(S.active.s);
        var entry = {
            id: ymd(S.active.s) + 'T' + toHm(d0.getHours() * 60 + d0.getMinutes()),
            s: S.active.s, e: endMs, t: S.active.t, u: Date.now()
        };
        S.log = S.log.filter(function (x) { return x.id !== entry.id; });
        S.log.push(entry);
        S.log.sort(function (a, b) { return b.s - a.s; });
        if (S.log.length > MAX_LOG) S.log.length = MAX_LOG;
        S.active = null;
        save(true);
        renderAll();
        cancelReminders();
        var full = mins >= entry.t * 60;
        toast((full ? t('log_done') : t('log_short')).replace(':d', dur(mins)), full ? 'success' : 'info');
        feature('fw_fast_end', { mins: Math.round(mins), target: entry.t, reached: full ? 1 : 0 });
        try { if (window.__aeToolComplete) window.__aeToolComplete({ mins: Math.round(mins), reached: full ? 1 : 0 }); } catch (e) {}
        pushSync();
    }

    function cancelFast() {
        if (!S.active) return;
        S.active = null;
        save(true);
        renderAll();
        cancelReminders();
        feature('fw_fast_cancel');
    }

    /* ─────────────────────────── журнал ─────────────────────────── */

    function reachedGoal(x) { return (x.e - x.s) / 3600000 >= x.t - 0.25; }

    function streak() {
        /* Серия — по КАЛЕНДАРНЫМ дням с доведённым до цели голоданием, назад
           от сегодня. Если сегодня записи ещё нет, отсчёт начинается со вчера:
           день не кончился, и обнулять серию в полдень было бы наказанием за
           то, что человек просто ещё не закрыл окно. */
        var byDay = {};
        S.log.forEach(function (x) { if (reachedGoal(x)) byDay[ymd(x.e)] = 1; });
        var n = 0, d = new Date();
        if (!byDay[ymd(d.getTime())]) d = new Date(d.getTime() - MS_DAY);
        while (byDay[ymd(d.getTime())]) { n++; d = new Date(d.getTime() - MS_DAY); }
        return n;
    }

    function renderJournal() {
        var el = $('fwJournal');
        if (!el) return;
        var total = S.log.length;
        var avg = total ? S.log.reduce(function (a, x) { return a + (x.e - x.s) / 60000; }, 0) / total : 0;
        var reached = S.log.filter(reachedGoal).length;

        var head = '<div class="fw-jstats">'
            + '<div class="fw-jstat"><b>' + streak() + '</b><span>' + esc(t('j_streak')) + '</span></div>'
            + '<div class="fw-jstat"><b>' + total + '</b><span>' + esc(t('j_total')) + '</span></div>'
            + '<div class="fw-jstat"><b>' + (total ? esc(dur(avg)) : '—') + '</b><span>' + esc(t('j_avg')) + '</span></div>'
            + '<div class="fw-jstat"><b>' + (total ? Math.round(reached / total * 100) + '%' : '—') + '</b><span>' + esc(t('j_reached')) + '</span></div>'
            + '</div>';

        var byDay = {};
        S.log.forEach(function (x) {
            var k = ymd(x.e), v = (x.e - x.s) / 3600000;
            byDay[k] = Math.max(byDay[k] || 0, v);
        });
        var today = new Date(); today.setHours(12, 0, 0, 0);
        var cells = [];
        var back = 83 + today.getDay();       // ровно 12 полных недель + текущая
        for (var i = back; i >= 0; i--) {
            var d = new Date(today.getTime() - i * MS_DAY);
            var k = ymd(d.getTime()), v = byDay[k] || 0;
            var lvl = v === 0 ? 0 : v < 12 ? 1 : v < 16 ? 2 : v < 20 ? 3 : 4;
            cells.push('<span class="fw-cell fw-l' + lvl + '" title="' + esc(k + (v ? ' · ' + dur(v * 60) : '')) + '"></span>');
        }
        var grid = '<div class="fw-heat" role="img" aria-label="' + esc(t('j_heat_alt')) + '">' + cells.join('') + '</div>';

        var list;
        if (total) {
            list = '<ul class="fw-jlist">' + S.log.slice(0, 8).map(function (x) {
                var v = (x.e - x.s) / 60000;
                return '<li><span class="fw-jdate">' + esc(dateFmt ? dateFmt.format(new Date(x.e)) : ymd(x.e)) + '</span>'
                    + '<span class="fw-jlen' + (reachedGoal(x) ? ' ok' : '') + '">' + esc(dur(v)) + '</span>'
                    + '<span class="fw-jgoal">' + esc(t('j_goal_short').replace(':h', x.t)) + '</span>'
                    + '<button type="button" class="fw-jdel" data-del="' + esc(x.id) + '" aria-label="' + esc(t('j_delete')) + '">×</button></li>';
            }).join('') + '</ul>';
        } else {
            list = '<p class="fw-empty">' + esc(t('j_empty')) + '</p>';
        }

        var tools = '<div class="fw-jtools">'
            + '<button type="button" class="lg-btn lg-btn-ghost lg-btn-sm" id="fwCsv">' + esc(t('j_csv')) + '</button>'
            + '<span class="fw-sync" id="fwSyncNote">' + esc(syncNote()) + '</span></div>';

        el.innerHTML = head + grid + list + tools;
    }

    function exportCsv() {
        var rows = [['start', 'end', 'hours', 'target_hours', 'reached']];
        S.log.slice().reverse().forEach(function (x) {
            var h = (x.e - x.s) / 3600000;
            rows.push([new Date(x.s).toISOString(), new Date(x.e).toISOString(), h.toFixed(2), x.t, reachedGoal(x) ? '1' : '0']);
        });
        // BOM — иначе Excel на Windows читает UTF-8 как cp1251.
        var csv = '\uFEFF' + rows.map(function (r) { return r.join(','); }).join('\r\n');
        var blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
        if (window.__downloadFile) window.__downloadFile(blob, 'fasting-log.csv');
        feature('fw_csv', { rows: S.log.length });
    }

    /* ─────────────────────────── синхронизация (Премиум) ─────────────────────────── */

    var syncState = 'guest';   // guest | off | on
    function canSync() {
        var tl = window.__tierLimits;
        return !!(tl && Array.isArray(tl.features) && tl.features.indexOf('fasting_cloud_sync') >= 0);
    }
    function syncNote() {
        if (syncState === 'on') return t('sync_on');
        if (syncState === 'off') return t('sync_off');
        return t('sync_guest');
    }
    function refreshSyncNote() {
        var el = $('fwSyncNote');
        if (el) el.textContent = syncNote();
    }
    function csrf() {
        var m = document.querySelector('meta[name="csrf-token"]');
        return m ? m.getAttribute('content') : '';
    }
    function wire() {
        return S.log.slice(0, MAX_LOG).map(function (x) { return { id: x.id, s: x.s, e: x.e, t: x.t, u: x.u || x.e }; });
    }
    function mergeIn(items) {
        if (!Array.isArray(items)) return;
        var byId = {};
        S.log.forEach(function (x) { byId[x.id] = x; });
        items.forEach(function (x) {
            if (!x || !x.id || typeof x.s !== 'number' || typeof x.e !== 'number') return;
            var cur = byId[x.id];
            if (!cur || (x.u || 0) > (cur.u || 0)) byId[x.id] = { id: x.id, s: x.s, e: x.e, t: x.t || 16, u: x.u || x.e };
        });
        S.log = Object.keys(byId).map(function (k) { return byId[k]; })
            .sort(function (a, b) { return b.s - a.s; }).slice(0, MAX_LOG);
        save(true);
    }
    var pushTimer = null;
    function pushSync() {
        if (!window.fetch || !canSync()) return;
        if (pushTimer) clearTimeout(pushTimer);
        pushTimer = setTimeout(function () {
            pushTimer = null;
            fetch(SYNC_URL, {
                method: 'POST', credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrf(), 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({ items: wire() })
            }).then(function (r) {
                if (r.status === 401) { syncState = 'guest'; return null; }
                if (r.status === 403) { syncState = 'off'; return null; }
                if (!r.ok) return null;
                syncState = 'on';
                return r.json();
            }).then(function (d) {
                if (d && d.items) mergeIn(d.items);
                renderJournal();
            }).catch(function () {});
        }, 800);
    }
    function pullSync() {
        var tl = window.__tierLimits;
        if (!window.fetch || !canSync()) {
            syncState = (tl && tl.tier_key && tl.tier_key !== 'anonymous') ? 'off' : 'guest';
            refreshSyncNote();
            return;
        }
        fetch(SYNC_URL, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (d) {
                if (!d) return;
                syncState = 'on';
                var before = S.log.length;
                mergeIn(d.items || []);
                renderJournal();
                if (S.log.length !== before || before) pushSync();
            }).catch(function () {});
    }

    /* ─────────────────────────── напоминания ─────────────────────────── */

    function notifySupported() { return typeof window.Notification !== 'undefined'; }

    /** Ближайшие границы на сутки вперёд — уже готовым локализованным текстом. */
    function reminderEvents() {
        if (!S.remind) return [];
        var out = [], now = Date.now();
        if (S.active) {
            var at = S.active.s + S.active.t * 3600000;
            if (at > now + 30000) out.push({ id: 'goal-' + S.active.s, at: at, title: t('nt_goal_t'), body: t('nt_goal_b').replace(':d', dur(S.active.t * 60)) });
        }
        var p = plan();
        [[p.eatStart, 'eat', t('nt_eat_t'), t('nt_eat_b')], [p.eatEnd, 'fast', t('nt_fast_t'), t('nt_fast_b')]].forEach(function (row) {
            for (var d = 0; d < 2; d++) {
                var dt = new Date();
                dt.setHours(0, 0, 0, 0);
                var at2 = dt.getTime() + d * MS_DAY + row[0] * 60000;
                if (at2 <= now + 30000) continue;
                out.push({ id: row[1] + '-' + ymd(at2), at: at2, title: row[2], body: row[3].replace(':time', clock(row[0])) });
            }
        });
        return out.sort(function (a, b) { return a.at - b.at; }).slice(0, 6);
    }

    var fgTimers = [];
    function clearForeground() { fgTimers.forEach(clearTimeout); fgTimers = []; }
    function armForeground() {
        clearForeground();
        if (!S.remind || !notifySupported() || Notification.permission !== 'granted') return;
        reminderEvents().forEach(function (ev) {
            var delay = ev.at - Date.now();
            if (delay <= 0 || delay > 12 * 3600000) return;
            fgTimers.push(setTimeout(function () {
                try {
                    if (navigator.serviceWorker && navigator.serviceWorker.ready) {
                        navigator.serviceWorker.ready.then(function (reg) {
                            reg.showNotification(ev.title, {
                                body: ev.body, tag: 'fw-' + ev.id, icon: '/favicon-192.png',
                                badge: '/favicon-192.png', data: { url: location.pathname }
                            });
                        }).catch(function () {});
                    } else { new Notification(ev.title, { body: ev.body, tag: 'fw-' + ev.id }); }
                } catch (e) {}
            }, delay));
        });
    }

    /* Уходя со вкладки, отдаём расписание Service Worker'у: там оно вооружается
       Notification Triggers (Chrome — переживает выгрузку страницы), а где их
       нет — обычным таймером самого SW. Ни один из путей не обещает больше,
       чем платформа может выполнить, и текст подсказки это называет. */
    function handOffToSW() {
        if (!navigator.serviceWorker || !navigator.serviceWorker.controller) return;
        if (!S.remind) return;
        try {
            navigator.serviceWorker.controller.postMessage({
                type: 'fw-schedule',
                events: reminderEvents().map(function (e) { return { id: e.id, fireAt: e.at, title: e.title, body: e.body }; }),
                url: location.pathname
            });
        } catch (e) {}
    }
    function cancelSWReminders() {
        if (!navigator.serviceWorker || !navigator.serviceWorker.controller) return;
        try { navigator.serviceWorker.controller.postMessage({ type: 'fw-cancel' }); } catch (e) {}
    }
    function scheduleReminders() { armForeground(); handOffToSW(); }
    function cancelReminders() { clearForeground(); cancelSWReminders(); }

    function toggleRemind() {
        if (S.remind) {
            S.remind = false; save(true); cancelReminders(); renderRemind();
            feature('fw_remind', { on: 0 });
            return;
        }
        if (!notifySupported()) { toast(t('nt_unsupported'), 'warning'); return; }
        Notification.requestPermission().then(function (perm) {
            if (perm !== 'granted') { toast(t('nt_denied'), 'warning'); renderRemind(); return; }
            S.remind = true; save(true); scheduleReminders(); renderRemind();
            toast(t('nt_on'), 'success');
            feature('fw_remind', { on: 1 });
        }).catch(function () {});
    }
    function renderRemind() {
        var b = $('fwRemind');
        if (!b) return;
        b.classList.toggle('on', !!S.remind);
        b.setAttribute('aria-pressed', S.remind ? 'true' : 'false');
        b.textContent = S.remind ? t('btn_remind_on') : t('btn_remind');
        var hint = $('fwRemindHint');
        if (hint) {
            hint.hidden = !S.remind;
            hint.textContent = notifySupported() ? t('nt_hint') : t('nt_unsupported');
        }
    }

    /* ─────────────────────────── календарь ─────────────────────────── */

    function icsStamp(date) {
        function p(n) { return String(n).padStart(2, '0'); }
        return date.getUTCFullYear() + p(date.getUTCMonth() + 1) + p(date.getUTCDate())
            + 'T' + p(date.getUTCHours()) + p(date.getUTCMinutes()) + p(date.getUTCSeconds()) + 'Z';
    }
    function icsLocal(mins) {
        var d = new Date();
        d.setHours(0, 0, 0, 0);
        d = new Date(d.getTime() + mins * 60000);
        function p(n) { return String(n).padStart(2, '0'); }
        return d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + 'T' + p(d.getHours()) + p(d.getMinutes()) + '00';
    }
    /** RFC 5545 требует складывать строки длиннее 75 октетов. */
    function icsFold(line) {
        if (line.length <= 72) return line;
        var out = line.slice(0, 72), rest = line.slice(72);
        while (rest.length) { out += '\r\n ' + rest.slice(0, 71); rest = rest.slice(71); }
        return out;
    }
    function icsEsc(s) { return String(s).replace(/([,;\\])/g, '\\$1').replace(/\n/g, '\\n'); }

    function exportIcs() {
        var p = plan();
        var lines = [
            'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Timbrica//Fasting Window//EN', 'CALSCALE:GREGORIAN',
            'BEGIN:VEVENT',
            'UID:fw-' + Date.now() + '@timbrica',
            'DTSTAMP:' + icsStamp(new Date()),
            'DTSTART:' + icsLocal(p.eatStart),
            'DTEND:' + icsLocal(p.eatStart + p.eatLen),
            'RRULE:FREQ=DAILY',
            'SUMMARY:' + icsEsc(t('ics_summary').replace(':scheme', t('s_' + S.scheme))),
            'DESCRIPTION:' + icsEsc(t('ics_desc')
                .replace(':eat', clock(p.eatStart) + ' — ' + clock(p.eatEnd))
                .replace(':fast', dur(p.fastLen))),
            'END:VEVENT', 'END:VCALENDAR'
        ].map(icsFold);
        var blob = new Blob([lines.join('\r\n') + '\r\n'], { type: 'text/calendar;charset=utf-8' });
        if (window.__downloadFile) window.__downloadFile(blob, 'fasting-window.ics');
        feature('fw_ics', { scheme: S.scheme });
    }

    /* ─────────────────────────── напитки ─────────────────────────── */

    var DRINKS = Array.isArray(window.FW_DRINKS) ? window.FW_DRINKS : [];
    function renderDrinks(q) {
        var el = $('fwDrinkList');
        if (!el) return;
        q = (q || '').trim().toLowerCase();
        var items = DRINKS.filter(function (d) {
            if (!q) return true;
            return (d.n + ' ' + (d.d || '') + ' ' + (d.k || '')).toLowerCase().indexOf(q) >= 0;
        });
        if (!items.length) {
            el.innerHTML = '<li class="fw-empty">' + esc(t('dr_none')) + '</li>';
            return;
        }
        el.innerHTML = items.map(function (d) {
            return '<li class="fw-drink fw-d-' + d.v + '">'
                + '<span class="fw-dv" aria-hidden="true">' + (d.v === 'ok' ? '✓' : d.v === 'no' ? '✕' : '≈') + '</span>'
                + '<span class="fw-dn">' + esc(d.n) + '<em class="fw-dvl">' + esc(t('dv_' + d.v)) + '</em></span>'
                + (d.d ? '<span class="fw-dd">' + esc(d.d) + '</span>' : '')
                + '</li>';
        }).join('');
    }

    /* ─────────────────────────── стадии: подробно ─────────────────────────── */

    function renderBody() {
        var el = $('fwBodyList');
        if (!el) return;
        el.innerHTML = STAGES.map(function (s, i) {
            var next = STAGES[i + 1];
            var range = next ? (s.from + '–' + next.from + ' ' + t('u_h')) : (s.from + '+ ' + t('u_h'));
            return '<li class="fw-bstage">'
                + '<span class="fw-brange">' + esc(range) + '</span>'
                + '<span class="fw-bmain"><b>' + esc(t('stage_' + s.id)) + '</b> '
                + '<span class="fw-ev fw-ev-' + s.ev + '">' + esc(t('ev_' + s.ev)) + '</span>'
                + '<span class="fw-bdesc">' + esc(t('stage_' + s.id + '_d')) + '</span></span>'
                + '</li>';
        }).join('');
    }

    /* ─────────────────────────── вкладки ─────────────────────────── */

    function setTab(id) {
        S.tab = id;
        save();
        Array.prototype.forEach.call(root.querySelectorAll('.fw-tab'), function (b) {
            var on = b.getAttribute('data-tab') === id;
            b.classList.toggle('on', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
            b.tabIndex = on ? 0 : -1;
        });
        Array.prototype.forEach.call(root.querySelectorAll('.fw-panel'), function (p) {
            p.hidden = p.getAttribute('data-panel') !== id;
        });
        if (id === 'journal') renderJournal();
    }

    function setMode(m) {
        if (S.mode === m) return;
        S.mode = m;
        save();
        renderControls();
        renderGeometry(true);
        renderCenter();
        feature('fw_mode', { mode: m });
    }

    /* ─────────────────────────── тик ─────────────────────────── */

    var tick = null;
    function onTick() {
        renderCenter();
        renderHand();
        /* Геометрия и производные блоки — только когда сменилась МИНУТА:
           перерисовывать разметку посекундно значит платить ею за цифру,
           которая живёт в одном текстовом узле. */
        var m = Math.floor(Date.now() / 60000);
        if (m !== onTick._m) {
            onTick._m = m;
            renderGeometry(true);
        }
    }
    function startTick() {
        stopTick();
        onTick();
        tick = setInterval(onTick, 1000);
    }
    function stopTick() { if (tick) { clearInterval(tick); tick = null; } }

    function renderAll() {
        renderControls();
        renderGeometry(true);
        renderCenter();
        renderHand();
        renderRemind();
        renderJournal();
    }

    /* ─────────────────────────── события ─────────────────────────── */

    function bind() {
        root.addEventListener('click', function (e) {
            var el = e.target && e.target.closest
                ? e.target.closest('[data-scheme],[data-mode],[data-tab],[data-goto],[data-del]') : null;
            if (!el || !root.contains(el)) return;
            var v;
            if ((v = el.getAttribute('data-scheme'))) {
                S.scheme = v;
                save();
                renderControls();
                renderGeometry(true);
                renderCenter();
                scheduleReminders();
                feature('fw_scheme', { scheme: S.scheme });
                stage('engaged');
                if (S.scheme === 'custom') { var ci = $('fwCustom'); if (ci) ci.focus(); }
                return;
            }
            if ((v = el.getAttribute('data-mode'))) { setMode(v); return; }
            if ((v = el.getAttribute('data-tab'))) { setTab(v); feature('fw_tab', { tab: v }); return; }
            if ((v = el.getAttribute('data-goto'))) {
                setTab(v);
                var host = root.querySelector('.fw-tabs');
                /* block:'nearest' обязателен — правило проекта: страницу не
                   прыгать, только доводить блок, если он за краем экрана. */
                if (host) host.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                feature('fw_tab', { tab: v, via: 'link' });
                return;
            }
            if ((v = el.getAttribute('data-del'))) {
                S.log = S.log.filter(function (x) { return x.id !== v; });
                save(true);
                renderJournal();
                pushSync();
                feature('fw_log_delete');
            }
        });

        // Стрелки внутри радиогруппы схем и обоих таблистов.
        root.addEventListener('keydown', function (e) {
            var group = e.target && e.target.closest ? e.target.closest('.fw-chips,.fw-tabs,.fw-modes') : null;
            if (!group) return;
            if (['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
            var items = Array.prototype.slice.call(group.querySelectorAll('button'));
            var i = items.indexOf(e.target);
            if (i < 0) return;
            e.preventDefault();
            var dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
            var next = items[(i + dir + items.length) % items.length];
            next.focus();
            next.click();
        });

        /* `input` рядом с `change` обязателен: нативный пикер времени на iOS
           шлёт `input` по мере кручения барабанов, а `change` — не при всяком
           уходе с поля (замер 2026-09-02: в поле уже 08:00, а окно всё ещё
           считалось от 12:00). */
        function timeField(id, apply) {
            var el = $(id);
            if (!el) return;
            ['change', 'input'].forEach(function (evt) {
                el.addEventListener(evt, function () {
                    var v = hm(el.value);
                    if (v == null) return;
                    apply(v);
                    save();
                    renderGeometry(true);
                    renderCenter();
                    scheduleReminders();
                    stage('engaged');
                });
            });
        }
        timeField('fwStart', function (v) { S.start = v; });
        timeField('fwSleepStart', function (v) { S.sleepStart = v; });
        timeField('fwSleepEnd', function (v) { S.sleepEnd = v; });
        timeField('fwStarted', function (v) {
            if (!S.active) return;
            var d = new Date(S.active.s);
            d.setHours(Math.floor(v / 60), v % 60, 0, 0);
            var ms = d.getTime();
            // Время позже «сейчас» может означать только вчера.
            if (ms > Date.now()) ms -= MS_DAY;
            S.active.s = ms;
        });

        var sOn = $('fwSleepOn');
        if (sOn) sOn.addEventListener('change', function () {
            S.sleepOn = sOn.checked;
            save();
            renderControls();
            renderGeometry(true);
            feature('fw_sleep', { on: S.sleepOn ? 1 : 0 });
        });

        var ci = $('fwCustom');
        if (ci) ['change', 'input'].forEach(function (evt) {
            ci.addEventListener(evt, function () {
                var v = parseInt(ci.value, 10);
                if (!isFinite(v)) return;
                S.customFast = Math.min(23, Math.max(10, v));
                save();
                renderGeometry(true);
                renderCenter();
            });
        });

        var go = $('fwGo');
        if (go) go.addEventListener('click', function () { if (S.active) finishFast(); else startFast(); });
        var cancel = $('fwCancel');
        if (cancel) cancel.addEventListener('click', cancelFast);
        var rem = $('fwRemind');
        if (rem) rem.addEventListener('click', toggleRemind);
        var ics = $('fwIcs');
        if (ics) ics.addEventListener('click', exportIcs);

        // Кнопка выгрузки живёт внутри перерисовываемого журнала — делегируем.
        root.addEventListener('click', function (e) {
            if (e.target && e.target.id === 'fwCsv') exportCsv();
        });

        var q = $('fwDrinkQ');
        if (q) {
            var qt = null;
            q.addEventListener('input', function () {
                renderDrinks(q.value);
                if (qt) clearTimeout(qt);
                /* Промах поиска — единственный источник правды о том, чего в
                   списке не хватает. Шлём с задержкой, чтобы не считать
                   каждую букву на пути к слову. */
                qt = setTimeout(function () {
                    var s = q.value.trim();
                    if (s.length >= 2) feature('fw_drink_search', { q: s.slice(0, 24).toLowerCase(), hits: $('fwDrinkList').querySelectorAll('.fw-drink').length });
                }, 1200);
            });
        }

        document.addEventListener('visibilitychange', function () {
            if (document.hidden) { stopTick(); handOffToSW(); }
            else { startTick(); armForeground(); }
        });
        window.addEventListener('pagehide', function () { stopTick(); handOffToSW(); });

        document.addEventListener('tier-bootstrap:ready', function () { pullSync(); });
    }

    /* ─────────────────────────── старт ─────────────────────────── */

    loadState();
    if (S.active) S.mode = 'timer';
    buildDial();
    bind();
    setTab(S.tab || 'drinks');
    renderDrinks('');
    renderBody();
    renderAll();
    startTick();
    if (S.remind) scheduleReminders();
    if (window.__tierLimits) pullSync(); else refreshSyncNote();
    stage('ready');

    if (window.__calcKit) {
        try {
            window.__calcKit.init({
                root: '#fwApp',
                shareInto: '#fwShareSlot',
                answer: function () { var e = $('fwStats'); return e ? e.textContent : ''; },
                share: function () {
                    var p = plan();
                    return t('share_line')
                        .replace(':scheme', t('s_' + S.scheme))
                        .replace(':eat', clock(p.eatStart) + ' — ' + clock(p.eatEnd))
                        .replace(':fast', clock(p.fastStart) + ' — ' + clock(p.eatStart));
                },
                meta: function () { return { scheme: S.scheme, start: toHm(S.start), sleep: S.sleepOn ? 1 : 0 }; }
            });
        } catch (e) {}
    }

    // Поверхность для стендов: считать состояние и пересчитать, не трогая DOM.
    window.__fasting = {
        state: function () { return S; },
        plan: plan,
        phase: phase,
        advice: advice,
        stageAt: stageAt,
        render: renderAll
    };
})();
